import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import user from './modules/user'
import navigation from './modules/navigation'
import search from './modules/search'

Vue.use(Vuex)

const store = new Vuex.Store({
  store : {
    helloWorld : 'Hello World!',
    
  },
  mutations : {
    //在这里定义修改helloWorld的方法,到时候调用SET_HW就可以修改了
    SET_HW (str) {
        this.helloWorld = str
    }
    ,
    
  },  
  modules: {
    user, navigation, search
  },
  getters
})

export default store
